import { useEffect, useState } from 'react';

export function useDebouncedValue<T>(value: T, delay: number, isObject: boolean = false): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (isObject) {
        if (JSON.stringify(debouncedValue) !== JSON.stringify(value)) {
          setDebouncedValue(value);
        }
      } else {
        setDebouncedValue(value);
      }
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
